import classes from './SalesSection.module.sass'
import { Button } from '../../../../../../common/components/button/Button'
import { useSalesSection } from './hooks/useSalesSection'
import { Modal } from '../../../../../../common/components/modal/Modal'
import {
  CAT_UPLOAD_ROUTE,
  CATEGORY_ROUTE,
  chatAdminId,
  CLUSTER_ROUTE,
  COMPLEX_ORDER_ROUTE,
  DOCUMENT_ROUTE,
  EXECUTOR_ROUTE,
  MOTIVATION_ROUTE,
  ORDER_ROUTE,
  PLACE_ROUTE,
  PRICE_ROUTE,
  PROMO_ROUTE,
  SALE_ITEM_ROUTE,
  STOCK_ROUTE,
  STORE_ROUTE,
} from '../../../../../../common/utils/constants'
import { Form } from './components/form/Form'
import { useSelector } from 'react-redux'
import { selectCurrentCluster } from '../../../../../../store/slices/currentClusterSlice'
import { selectCurrentUser } from '../../../../../../store/slices/currentUserSlice'

export const SalesSection = () => {
  const { modalActive, setModalActive, getClusters, loading, setLoading } = useSalesSection()
  const currenCluster = useSelector(selectCurrentCluster)
  const currentUser = useSelector(selectCurrentUser)

  const isClusterBlocked = !currenCluster?.isActive
  const isSuperAdmin = currentUser?.id === chatAdminId
  const isClusterAdmin =
    currentUser?.user_clusters?.some((uc) => uc === currenCluster?.id) || isSuperAdmin

  // Если пользователь не админ кластера и не суперадмин — не показываем секцию
  if (!isClusterAdmin) return null

  return (
    <div className={classes.Container}>
      {!currenCluster?.token ? (
        <></>
      ) : (
        <>
          <div className={classes.Buttons}>
            <div className={classes.ButtonsSection}>
              <Button text={'Кластер'} href={CLUSTER_ROUTE} />
              <Button text={'Точки'} href={STORE_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Категории'} href={CATEGORY_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Товары'} href={SALE_ITEM_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Мотивация'} href={MOTIVATION_ROUTE} disabled={isClusterBlocked} />
              {isSuperAdmin && (
                <>
                  <Button text={'Места'} href={PLACE_ROUTE} disabled={isClusterBlocked} />
                  <Button text={'Загрузка каталога'} href={CAT_UPLOAD_ROUTE} />
                </>
              )}
            </div>
            <div className={classes.ButtonsSection}>
              <Button text={'Цены'} href={PRICE_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Остатки'} href={STOCK_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Акции'} href={PROMO_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Заказы'} href={ORDER_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Проекты'} href={COMPLEX_ORDER_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Исполнители'} href={EXECUTOR_ROUTE} disabled={isClusterBlocked} />
              <Button text={'Документы'} href={DOCUMENT_ROUTE} disabled={isClusterBlocked} />
              {/* {isSuperAdmin && (
                <>
                  <Button disabled text={'Бронирование'} href={PLACE_ROUTE} />
                </>
              )} */}
            </div>
          </div>
          {isSuperAdmin && (
            <Button text={'Сгенерировать кластер'} onClick={() => setModalActive(true)} />
          )}
        </>
      )}
      <Modal cantClose={loading} modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          setModalActive={setModalActive}
          getClusters={getClusters}
          loading={loading}
          setLoading={setLoading}
        />
      </Modal>
    </div>
  )
}
